module.exports = __webpack_public_path__ + "img/case02.d15ace88.png";